import React from 'react';

export default function MainFooter() {
  return (
    <footer className="py-4 border-top bg-white">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
        <small className="text-muted">© {new Date().getFullYear()} Trainable AI Agent</small>
        <div className="d-flex gap-3">
          <a href="#" className="link-secondary" style={{ cursor: 'pointer' }}>Docs</a>
          <a href="#" className="link-secondary" style={{ cursor: 'pointer' }}>Status</a>
          <a href="#" className="link-secondary" style={{ cursor: 'pointer' }}>Privacy</a>
        </div>
      </div>
    </footer>
  );
}
